import React from 'react'
import { MANTHLY_ROTATION_ITEM_DETAIL } from '../urls'
import { usePutRequest } from '../hooks/request'
import ServerError from './componentsFinance/common/ServerError'
import ManthlyRotationItemForm from './ManthlyRotationItemForm'

export default function ManthlyRotationItemUpdate({ onCancel, onSuccess, reportItem, finance, rotationId }) {
    const url = MANTHLY_ROTATION_ITEM_DETAIL.replace('{id}', reportItem.id)
    const rotationItemUpdate = usePutRequest({ url })

    async function onSubmit(data) {
        const { success } = await rotationItemUpdate.request({ data })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <b>Изменить данные</b><br /><br />
            <ServerError error={rotationItemUpdate.error} />
            <ManthlyRotationItemForm
                initialValues={reportItem}
                onSubmit={onSubmit}
                onCancel={onCancel}
                rotationId={rotationId}
                finance={finance}
                loading={rotationItemUpdate.loading} />
        </div>
    )
}
